document.querySelectorAll('[data-bf-tabs]:not([data-bf-ready])').forEach(function (root) {
  root.setAttribute('data-bf-ready', '');
  var tabs = root.querySelectorAll('[data-bf-tab]');
  var panels = root.querySelectorAll('[data-bf-panel]');
  var busy = false;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FADE_MS = 260;
  var STAGGER_MS = 40;

  function syncSlider(panel) {
    var slider = panel.querySelector('[data-bf-slider]');
    if (slider && slider._bfSync) {
      requestAnimationFrame(slider._bfSync);
    }
  }

  function fadeDuration(panel) {
    var count = panel.querySelectorAll('.bf-card').length || 1;
    return FADE_MS + (Math.min(count, 12) - 1) * STAGGER_MS;
  }

  function wait(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  function hidePanel(panel) {
    if (!panel) return Promise.resolve();
    if (reduceMotion) {
      panel.classList.add('is-hidden');
      return Promise.resolve();
    }
    panel.classList.add('is-fading-out');
    return wait(fadeDuration(panel)).then(function () {
      panel.classList.add('is-hidden');
      panel.classList.remove('is-fading-out');
    });
  }

  function showPanel(panel) {
    if (reduceMotion) {
      panel.classList.remove('is-hidden');
      syncSlider(panel);
      return Promise.resolve();
    }

    panel.classList.add('is-fading-in');
    panel.classList.remove('is-hidden');
    syncSlider(panel);
    void panel.offsetWidth;
    panel.classList.remove('is-fading-in');
    panel.classList.add('is-fading-in-active');

    return wait(fadeDuration(panel)).then(function () {
      panel.classList.remove('is-fading-in-active');
    });
  }

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var id = tab.getAttribute('data-bf-tab');
      var next = null;
      var current = null;

      panels.forEach(function (p) {
        if (p.getAttribute('data-bf-panel') === id) next = p;
        if (!p.classList.contains('is-hidden')) current = p;
      });

      if (!next || next === current || busy) return;

      tabs.forEach(function (t) {
        var active = t === tab;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      busy = true;
      hidePanel(current)
        .then(function () {
          return showPanel(next);
        })
        .then(function () {
          busy = false;
        });
    });
  });
});
